/**
 *
 * Criação do objecto de utilizador/ perfil.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados.
 *
 * @param {Object}  data
 *
*/
const create = ( data, helpers ) => {
    const user = {
        ...( helpers.id && { id: helpers.id }),
        ...( data.name && { name: data.name }),
        ...( data.email && { email: data.email }),
        ...( data.password && { password: data.password })
    };

    return user;
};

const requiredFields = [
    { field: 'name', isRequiredOnEdit: false },
    { field: 'email', isRequiredOnEdit: false },
    { field: 'confirmPassword', isRequiredOnEdit: false }
];

export {
    create,
    requiredFields
};